import { ProductInterval, standard } from "data/products";

const DOMAIN = process.env.NEXT_PUBLIC_URL;

export const buildSoftwareApplicationSchema = (
  url: string,
  description: string,
) => {
  const startingPrice =
    standard.getPaymentInformation(2, ProductInterval.YEAR).amountPerMonth /
    100;

  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "VisualOrc",
    description,
    url: DOMAIN?.concat(url) ?? url,
    applicationCategory: "BusinessApplication",
    operatingSystem: "Windows",
    offers: [
      {
        "@type": "Offer",
        price: "0",
        priceCurrency: "EUR",
        eligibleDuration: {
          "@type": "QuantitativeValue",
          value: 7,
          unitCode: "DAY",
        },
      },
      {
        "@type": "Offer",
        price: startingPrice.toFixed(2),
        priceCurrency: "EUR",
        url: DOMAIN?.concat("/planos-e-precos") ?? "/planos-e-precos",
        // Plans are billed monthly (data/products.ts' amountPerMonth), so the
        // flat "price" alone could read as a one-time charge; this clarifies
        // it recurs every month.
        priceSpecification: {
          "@type": "UnitPriceSpecification",
          price: startingPrice.toFixed(2),
          priceCurrency: "EUR",
          billingDuration: "P1M",
        },
      },
    ],
  };
};
